/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 27/11/2023
 */

import { apiSlice } from "../Slices/apiSlice";

export const AddressService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllAddresses: builder.query({
      query: () => "/user-contact/by-user",
      providesTags: ["address"],
    }),

    getAddressById: builder.query({
      query: (userContactId) => `user-contact/${userContactId}`,
      providesTags: ["address"],
    }),

    createAddress: builder.mutation({
      query: (details) => ({
        url: "/user-contact",
        method: "POST",
        body: details,
      }),
      invalidatesTags: ["address"],
    }),

    updateAddress: builder.mutation({
        query: (details) => {
          return {
            url: `user-contact/${details.userContactId}`,
            method: "PUT",
            body: details,
          };
        },
        invalidatesTags: ["address"],
      }),

    deleteAddress: builder.mutation({
      query: (id) => ({
        url: `/user-contact/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["address"],
    }),
  }),
});

export const {
  useGetAllAddressesQuery,
  useLazyGetAllAddressesQuery,
  useGetAddressByIdQuery,
  useCreateAddressMutation,
  useUpdateAddressMutation,
  useDeleteAddressMutation,
} = AddressService;
